import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Container from "../../components/Container"
import OutdoorAreaGalleryComponent from "../../components/gallery/OutdoorAreaGalleryComponent"

const OutdoorAreaGalleryPage = () => (
  <Layout>
    <SEO title="Gallery" />
    <Container
      noTitle
      style={{
        background: `#52575a`,
        color: `white`,
      }}
      whitetitle
    >
      <OutdoorAreaGalleryComponent />
    </Container>
  </Layout>
)

export default OutdoorAreaGalleryPage
